import { theme } from 'antd';
import styled from "styled-components";

const { defaultAlgorithm, defaultSeed } = theme;
const mapToken = defaultAlgorithm(defaultSeed);

export const BankFeedTransactionLineDiv = styled.div`
  padding: 16px;
  margin: 8px 0;
  background-color: #e3f0ff;
  border-radius: 8px;
  
  .title {
    font-weight: bold;
  }

  .subtitle {
    margin-top: 4px;
    font-style: italic;
    color: ${mapToken.colorTextSecondary};
    text-align: right;
  }
`;
